var map = {
	"./00_Dyname.png": 468,
	"./02_Horto.png": 2249,
	"./04_NPmedia.png": 3045,
	"./05_Otherwise.png": 5183,
	"./06_ALegal.png": 7505,
	"./07_DBService.png": 2728,
	"./08_HotelCanon.png": 9934,
	"./09_Meitei.png": 6109,
	"./10_Sonda.png": 9289,
	"./11_Lazzaris.png": 796,
	"./13_Stella.png": 1864,
	"./16_Kairos.png": 9344,
	"./17_Fiori.png": 5560,
	"./18_Handpan.png": 8061
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7901;